/* Sales UI only. No tracking, cookies, personal-data storage or automatic submissions. */
(function () {
  'use strict';
  function init(scope) {
    var roots = [];
    if (scope.matches && scope.matches('[data-ss-selling]')) roots.push(scope);
    scope.querySelectorAll('[data-ss-selling]').forEach(function (el) { roots.push(el); });
    roots.forEach(function (root) {
      root.querySelectorAll('[data-ss-selling-variant]').forEach(function (select) {
        if (select.dataset.ssVariantReady) return;
        var card = select.closest('[data-ss-selling-card]');
        if (!card) return;
        select.dataset.ssVariantReady = '1';
        function update() {
          var opt = select.selectedOptions[0];
          if (!opt) return;
          var price = card.querySelector('[data-ss-selling-price]');
          var status = card.querySelector('[data-ss-selling-status]');
          var button = card.querySelector('[data-ss-selling-add]');
          if (price) price.textContent = opt.dataset.price;
          if (status) {
            status.textContent = opt.dataset.status;
            status.dataset.deliveryStatus = opt.dataset.statusKind || 'unknown';
          }
          card.querySelectorAll('[data-ss-selling-variant-link], [data-ss-selling-details]').forEach(function (link) {
            if (opt.dataset.url) link.href = opt.dataset.url;
          });
          if (button) {
            var available = opt.dataset.available === 'true';
            button.disabled = !available;
            button.textContent = available ? button.dataset.ready : button.dataset.unavailable;
          }
        }
        select.addEventListener('change', update);
        update();
      });
      root.querySelectorAll('form[data-ss-selling-contact]').forEach(function (form) {
        if (form.dataset.ssContactReady) return;
        form.dataset.ssContactReady = '1';
        var ret = form.querySelector('[name="return_to"]');
        if (ret) {
          try {
            var source = new URL(window.location.href);
            var target = new URL(source.pathname, source.origin);
            ['view', 'preview_theme_id'].forEach(function (key) {
              var value = source.searchParams.get(key);
              if (value && ((key === 'preview_theme_id' && /^\d+$/.test(value)) ||
                  (key === 'view' && /^[a-z0-9-]+$/i.test(value)))) target.searchParams.set(key, value);
            });
            target.hash = form.id;
            ret.value = target.pathname + target.search + target.hash;
          } catch (_) { /* Keep the server-generated return path if the URL is unavailable. */ }
        }
        var message = form.querySelector('[data-ss-selling-result]');
        if (message) message.focus();
      });
    });
    var panel = document.querySelector('[data-ss-calculator-next]');
    var results = document.getElementById('ss-upsell');
    var quote = document.getElementById('ss-offer-form');
    if (panel && results && quote && !panel.dataset.moved) {
      results.insertAdjacentElement('afterend', panel);
      panel.dataset.moved = '1';
      var link = panel.querySelector('[data-ss-calculator-quote]');
      if (link) {
        link.href = '#' + quote.id;
        link.addEventListener('click', function () {
          var name = quote.querySelector('[name="contact[name]"]');
          if (name) setTimeout(function () { name.focus({preventScroll: true}); }, 100);
        });
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
